import React from 'react';
import Card from "@material-ui/core/Card"
import {CardHeader, CardText} from '@material-ui/core/Card';
export default class Contact extends React.Component {

  render(){

      return (
        <Card shadow={0} style={{ margin: 'auto', textAlign: 'center' }}>
           <CardHeader
             title="Contact Fun-To_Find"
             subtitle="Find us"
             actAsExpander={true}
           />
           <CardText  >
             The joys of being on the water
           </CardText>
        </Card>
      );
  }
}



// WEBPACK FOOTER //
// ./src/Component/Contact.js